import React, { Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import * as FieldUtil from '../../util/public/fieldUtil';
import { getEcCom, getLabel } from '../../util/convert';

@inject('globalStore', 'layoutStore')
@observer
export default class SecLevelField extends React.Component {
    doChange = (v) => {
        this.props.layoutStore.changeSingleFieldValue("field-10", { value: v });
    }
    render() {
        const { WeaSelect, WeaInput } = getEcCom();
        const { viewAttr, globalStore } = this.props;
        const { secLevelInfo = {}, setSecLevelInfo, JSComplete } = globalStore;
        const { secValidityMap = {}, secValidity } = secLevelInfo;
        let value = secLevelInfo.secLevel || "";
        const canEdit = secLevelInfo.canSecChange && viewAttr > 1 ? 3 : 1;
        if (canEdit === 1)
            return this.getShowOnlyContent();
        const showSecValidity = value == 2 || value == 1;
        const options = [];
        const fieldObj = FieldUtil.getMainFieldObj("field-10")
        const { variable } = fieldObj;
        const optionRange = variable.has("optionRange") ? variable.get("optionRange") : null;
        const filterOptionRange = variable.has("filterOptionRange") ? variable.get("filterOptionRange") : null;
        const itemList = toJS(secLevelInfo.secLevelOption);
        itemList && itemList.map(item => {
            if (optionRange !== null && _.indexOf(optionRange, item.key) === -1)	//选择框联动控制范围
                return true;
            if (filterOptionRange !== null && _.indexOf(filterOptionRange, item.key) > -1)   //接口控制remove选项
                return true;
            options.push(item);
        })
        if (options && options.length > 0 && options.filter(o => o.key == value).length == 0 && value !== "") {
            value="";
            this.doChange("");
        }
        return (
            <Fragment>
                <WeaSelect ecId={`${this && this.props && this.props.ecId || ''}_WeaSelect@gt5c9l`}
                    viewAttr={canEdit}
                    onChange={this.doChange}
                    options={options}
                    value={value}
                    style={{ minWidth: "60px", marginRight: showSecValidity ? "10px" : "" }}
                />
                {showSecValidity && WeaInput && <WeaInput
                    helpfulTip={getLabel(528340, "保密期限填写格式：3个月、10年、20年、长期…不能是纯数字")}
                    helpfulTipProps={
                        {
                            style: {
                                right: "-34px",
                                position: "absolute",
                                top: "8px"
                            }
                        }
                    }
                    placeholder={getLabel(530018, "请输入保密期限")}
                    id="field-10"
                    style={{ width: "100px" }}
                    value={secValidity}
                    viewAttr={canEdit}
                    onChange={val => {
                        setSecLevelInfo({ secValidity: val });
                        secValidityMap[value] = val
                    }}
                />}
            </Fragment>

        )
    }

    getShowOnlyContent = () => {
        const { viewAttr, globalStore } = this.props;
        const { secLevelInfo = {} } = globalStore;
        const { secValidityMap = {}, secValidityDefaultMap = {} } = secLevelInfo;
        const value = secLevelInfo.secLevel || "";
        const showOnlySecValidity = secValidityMap[value] || "";
        let content = FieldUtil.getSecLevelName(value);
        if (value == 1 || value == 2) {
            if (secValidityDefaultMap[value] == "0") {//显示密级和保密期限
                content += `${showOnlySecValidity ? '★' : ""}` + showOnlySecValidity
            } else {//仅显示密级

            }
        }
        return <span id={`field-10span`}>{content}</span>
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/fieldType/SecLevelField.js